import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import SeoMeta from '../Components/Common/SeoMeta';

const Sitemap = () => {
    const navigate = useNavigate();
    const handleClick = (path) => {
        // navigate(path);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
        <>
            <SeoMeta
                title="Sitemap | New and Pre-Owned McLaren For Sale | McLaren Orlando"
                description="Use our sitemap to view all the pages on our website on one location. McLaren Orlando is your source for new and used McLarens in Orlando, FL."
                keywords=""
                ogTitle="Sitemap | New and Pre-Owned McLaren For Sale | McLaren Orlando"
                ogDescription="Use our sitemap to view all the pages on our website on one location. McLaren Orlando is your source for new and used McLarens in Orlando, FL."
            />
            <section className='sitemap-wrap pt-200'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <ul className="sitemap">
                                <li>
                                    <Link onClick={
                                        handleClick
                                    } to="/">Home</Link>
                                </li>
                                <li>
                                    <Link onClick={
                                        handleClick
                                    } to="/sell-or-trade">Sell Us Your Car</Link>
                                </li>
                                <li>
                                    <Link onClick={
                                        handleClick
                                    } to="/order-parts">Parts</Link>
                                </li>
                                <li>
                                    <Link onClick={
                                        handleClick
                                    } to="/about-staff">About Us</Link>
                                </li>
                            </ul>
                        </div>
                        <div className='col-md-4'>
                            <ul className="sitemap">
                                <li>
                                    <Link onClick={
                                        handleClick
                                    } to="/contact">Contact</Link>
                                </li>
                                {/*<li>
                                    <Link onClick={
                                        handleClick
                                    } to="/consignment-agreement">Consignment Agreement</Link>
                                </li>*/}
                                <li>
                                    <Link onClick={
                                        handleClick
                                    } to="/blog">Blog</Link>
                                </li>
                                <li>
                                    <Link onClick={
                                        handleClick
                                    } to="/shopping">Shopping</Link>
                                </li>
                                <li>
                                    <Link onClick={
                                        handleClick
                                    } to="/gts">GTS</Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <ul className="sitemap">
                        <li>
                            <div className='pt-4'>
                                <div className="row">
                                    <div className="col-12 col-sm-6 col-md-4">
                                        <Link onClick={
                                            handleClick
                                        } to="/inventory">Inventory</Link>
                                        <ul className='sitemap_level2 mt-1'>
                                            <li>
                                                <Link onClick={
                                                    handleClick
                                                } to="/inventory/new">New Inventory</Link>
                                            </li>
                                            <li>
                                                <Link onClick={
                                                    handleClick
                                                } to="/inventory/used">Pre-Owned Inventory</Link>
                                            </li>
                                            <li>
                                                <Link onClick={
                                                    handleClick
                                                } to="/inventory/certified-used">Certified Pre-Owned</Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-4">
                                        <Link onClick={
                                            handleClick
                                        } to="/finance-calculator">Finance</Link>
                                        <ul className='sitemap_level2 mt-1'>
                                            <li>
                                                <Link onClick={
                                                    handleClick
                                                } to="/finance-calculator" state={{ openModal: true }} target="_blank">Finance Application</Link>
                                            </li>
                                            <li>
                                                <Link onClick={
                                                    handleClick
                                                } to="/finance-calculator" target="_blank">Finance Calculator</Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-4">
                                        <Link onClick={
                                            handleClick
                                        } to="/service">Service</Link>
                                        <ul className='sitemap_level2 mt-1'>
                                            <li>
                                                <Link onClick={
                                                    handleClick
                                                } to="/service" state={{ openRequestModal: true }}>Request An Appointment</Link>
                                            </li>
                                            <li>
                                                <Link onClick={
                                                    handleClick
                                                } to="/roadside-assistance">Roadside Assistance</Link>
                                            </li>
                                            <li>
                                                <Link onClick={
                                                    handleClick
                                                } to="/lease-return">McLaren Lease Return</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
        </>
    )
}

export default Sitemap